import { render, staticRenderFns } from "./FooterImpressao.vue?vue&type=template&id=d369894c&scoped=true&"
import script from "./FooterImpressao.vue?vue&type=script&lang=js&"
export * from "./FooterImpressao.vue?vue&type=script&lang=js&"
import style0 from "./FooterImpressao.vue?vue&type=style&index=0&id=d369894c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d369894c",
  null
  
)

export default component.exports